<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Moneda"
                        aria-label="Agregar Moneda"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
      </b-card>
      
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">                                     

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(symbol)="data">
                  <b>{{data.item.symbol}}</b>
                </template>

                <template v-slot:cell(status)="data">
                  <b-badge variant="success" v-if="data.item.status">Activo</b-badge>
                  <b-badge variant="danger" v-else>Inactivo</b-badge>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-currency-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else
                        icon="payments"
                        title="No se encontraron monedas"
                        description="Agregá una moneda para usarla en listas de precios y operaciones." />

            <div class="app-table-footer">
              <span class="list-view-toolbar__count">{{ getRowCount(table.items) }} registros</span>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>

          <nav>
            <b-pagination class="pull-right mb-0"
                          size="sm"
                          pills=""
                          :total-rows="getRowCount(table.items)"
                          :per-page="table.perPage"
                          v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>      

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="payments" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="6">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>  

          <b-col md="6">
            <b-form-group label="Código">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.code"
                            required
                            placeholder="Ingresar un código de moneda">
              </b-form-input>
            </b-form-group>
          </b-col>  
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Símbolo">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.symbol"
                            required
                            placeholder="Ingresar un símbolo">
              </b-form-input>
            </b-form-group>
          </b-col>   

          <b-col md="6">
            <b-form-group label="Tasa de Cambio">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.rate">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Estado"
                          :description="isBaseCurrency ? 'El Peso Argentino no se puede inactivar: está configurado como moneda por default en todo el sistema.' : ''">
              <b-form-checkbox v-model="crud.form.status"
                                switch
                                size="sm"
                                :disabled="isBaseCurrency">
                {{crud.form.status ? 'Activo' : 'Inactivo'}}
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">
            <AppIcon name="x" class="mr-1" />Cancelar
          </b-button>
          <b-button variant="dark" @click="save()">
            <AppIcon name="save" class="mr-1" />Guardar
          </b-button>
        </div>
      </b-modal>
      
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.PRECIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudCurrency',
          elements: {}
        }, 
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 50,
        },
        isMobileViewport: false,
        crud: {
          form: {
            id: 0,
            name: '',
            code: '',
            symbol: '',
            rate: '',
            status: true,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        }
      }
    },
    computed: {
      // El Peso Argentino (id 1) es la única moneda que no se puede
      // inactivar -- ver comentario de BASE_CURRENCY_ID en
      // CurrencyController.php del backend para el motivo.
      isBaseCurrency() {
        return this.crud.form.id === 1
      },
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    mounted() {
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.configureFields()
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.load()

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      // Esta vista no tiene botón de filtro/actualizar -- si se agrega una
      // moneda desde el quick-add de otro combo (CurrencyQuickAdd, dentro de
      // FindObject) mientras esta pestaña ya estaba cargada (keep-alive), la
      // tabla queda desactualizada hasta que se vuelve a entrar. Recargamos
      // acá para que alcance con volver a la pestaña.
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
        this.configureFields()
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      configureFields() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-left')},
          {key: 'name', label: 'Moneda', class: 'align-middle ' + this.alignClass('text-left')},
          {key: 'code', label: 'Código', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'symbol', label: 'Simbolo', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'rate', label: 'Tasa de Cambio', class: 'align-middle ' + this.alignClass('text-right')},
          {key: 'status', label: 'Estado', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'f_action', label: this.isMobileViewport ? 'Accion' : '', class: 'align-middle ' + this.alignClass('text-right')},
        ]
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerMoneda()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.code = ''
        this.crud.form.symbol = ''
        this.crud.form.rate = 0
        this.crud.form.status = true

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Moneda"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.code = item.code
        this.crud.form.symbol = item.symbol
        this.crud.form.rate = item.rate
        this.crud.form.status = item.status !== undefined ? item.status : true

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Moneda"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Moneda',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            if(item.id==1 || item.id==2 || item.id==3 || item.id==4) {
              this.$awn.alert('No se puede eliminar la moneda');
              return false
            }
            
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarMoneda(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        if(this.isBaseCurrency && !this.crud.form.status) {
          this.$awn.alert('El Peso Argentino no se puede inactivar');
          return false
        }

        let loader = this.$loading.show();
        var result = null
        if (this.crud.form.id) {
          result = serviceAPI.editarMoneda(this.crud.form);
        } else {
          result = serviceAPI.agregarMoneda(this.crud.form);
        }

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }    
  }
</script>
<style>
  .btn.crud-currency-action-toggle-labeled {
    align-items: center;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    display: inline-flex !important;
    font-size: var(--app-text-sm);
    height: auto !important;
    justify-content: flex-start;
    min-height: 0;
    padding: 0 !important;
    width: auto !important;
  }

  .btn.crud-currency-action-toggle-labeled:hover,
  .btn.crud-currency-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
</style>
